// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Caml_splice_call = require("rescript/lib/js/caml_splice_call.js");
var Expln_utils_data = require("../../rescript-utils/main/Expln_utils_data.bs.js");
var Belt_MutableStack = require("rescript/lib/js/belt_MutableStack.js");

function validateValue(value, allowedValues, valueType) {
  if (allowedValues.includes(value)) {
    return {
            TAG: /* Ok */0,
            _0: undefined
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "" + valueType + " \"" + value + "\" is not supported."
          };
  }
}

var allowedTags = [
  "div",
  "p",
  "span",
  "ol",
  "ul",
  "li",
  "pre",
  "table",
  "tbody",
  "thead",
  "tr",
  "td",
  "a",
  "hr",
  "b",
  "i",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6"
];

var styleAttrs = [
  "color",
  "font-weight",
  "font-family",
  "font-style",
  "font-size"
];

var otherAttrs = ["href"];

var supportedAttrs = styleAttrs.concat(otherAttrs);

function isIncludedIntoAllowedValues(value, allowedValues, attrName) {
  if (allowedValues.includes(value)) {
    return {
            TAG: /* Ok */0,
            _0: undefined
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "Value of \"" + value + "\" is not supported by \"" + attrName + "\" attribute. All the supported values are: " + allowedValues.join(", ") + " ."
          };
  }
}

var fontSizeValuePattern = /^\d+(.\d+)?em$/;

function createStyle(attrs, addBorder) {
  if (!(Belt_Option.isSome(Belt_MapString.findFirstBy(attrs, (function (attr, param) {
                  return styleAttrs.includes(attr);
                }))) || addBorder)) {
    return ;
  }
  var tmp = {};
  var tmp$1 = addBorder ? "1px solid black" : undefined;
  if (tmp$1 !== undefined) {
    tmp.border = tmp$1;
  }
  var tmp$2 = addBorder ? "collapse" : undefined;
  if (tmp$2 !== undefined) {
    tmp.borderCollapse = tmp$2;
  }
  var tmp$3 = Belt_MapString.get(attrs, "color");
  if (tmp$3 !== undefined) {
    tmp.color = tmp$3;
  }
  var tmp$4 = Belt_MapString.get(attrs, "font-family");
  if (tmp$4 !== undefined) {
    tmp.fontFamily = tmp$4;
  }
  var tmp$5 = Belt_MapString.get(attrs, "font-size");
  if (tmp$5 !== undefined) {
    tmp.fontSize = tmp$5;
  }
  var tmp$6 = Belt_MapString.get(attrs, "font-style");
  if (tmp$6 !== undefined) {
    tmp.fontStyle = tmp$6;
  }
  var tmp$7 = Belt_MapString.get(attrs, "font-weight");
  if (tmp$7 !== undefined) {
    tmp.fontWeight = tmp$7;
  }
  return tmp;
}

function createDomProps(attrs, addBorder) {
  if (!(Belt_MapString.size(attrs) !== 0 || addBorder)) {
    return ;
  }
  var tmp = {};
  var tmp$1 = createStyle(attrs, addBorder);
  if (tmp$1 !== undefined) {
    tmp.style = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Belt_MapString.get(attrs, "href");
  if (tmp$2 !== undefined) {
    tmp.title = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = Belt_MapString.get(attrs, "href");
  if (tmp$3 !== undefined) {
    tmp.href = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = Belt_Option.map(Belt_MapString.get(attrs, "href"), (function (param) {
          return "_blank";
        }));
  if (tmp$4 !== undefined) {
    tmp.target = Caml_option.valFromOption(tmp$4);
  }
  var tmp$5 = Belt_MapString.get(attrs, "font-weight");
  if (tmp$5 !== undefined) {
    tmp.fontWeight = Caml_option.valFromOption(tmp$5);
  }
  return Caml_option.some(tmp);
}

function xmlToReactElem(xml) {
  var saveChild = function (childrenStack, child) {
    var match = Belt_MutableStack.top(childrenStack);
    if (match !== undefined) {
      match[1].push(child);
      return ;
    } else {
      return Js_exn.raiseError("childrenStack->Belt_MutableStack.top is None");
    }
  };
  var match = Expln_utils_data.traverseTree(Belt_MutableStack.make(undefined), xml, (function (param, node) {
          if (node.TAG === /* Node */0) {
            return node.children;
          }
          
        }), undefined, (function (childrenStack, node) {
          if (node.TAG === /* Node */0) {
            Belt_MutableStack.push(childrenStack, [
                  node.name,
                  []
                ]);
          }
          
        }), (function (childrenStack, node) {
          var parentTagName = Belt_Option.getWithDefault(Belt_Option.map(Belt_MutableStack.top(childrenStack), (function (param) {
                      return param[0];
                    })), "");
          var thisElem;
          if (node.TAG === /* Node */0) {
            var attrs = node.attrs;
            var name = node.name;
            var msg = validateValue(name, allowedTags, "Tag");
            if (msg.TAG === /* Ok */0) {
              var attrValidation = Belt_MapString.reduce(attrs, {
                    TAG: /* Ok */0,
                    _0: undefined
                  }, (function (res, attrName, attrValue) {
                      if (res.TAG === /* Ok */0) {
                        var msg = validateValue(attrName, supportedAttrs, "Attribute");
                        if (msg.TAG !== /* Ok */0) {
                          return {
                                  TAG: /* Error */1,
                                  _0: msg._0
                                };
                        }
                        switch (attrName) {
                          case "color" :
                              return isIncludedIntoAllowedValues(attrValue, [
                                          "aqua",
                                          "black",
                                          "blue",
                                          "fuchsia",
                                          "gray",
                                          "green",
                                          "lime",
                                          "maroon",
                                          "navy",
                                          "olive",
                                          "purple",
                                          "red",
                                          "silver",
                                          "teal",
                                          "white",
                                          "yellow"
                                        ], attrName);
                          case "font-family" :
                              return isIncludedIntoAllowedValues(attrValue, [
                                          "serif",
                                          "sans-serif",
                                          "monospace",
                                          "cursive",
                                          "fantasy",
                                          "system-ui",
                                          "ui-serif",
                                          "ui-sans-serif",
                                          "ui-monospace",
                                          "ui-rounded",
                                          "emoji",
                                          "math",
                                          "fangsong"
                                        ], attrName);
                          case "font-size" :
                              var match = attrValue.match(fontSizeValuePattern);
                              if (match !== null) {
                                return {
                                        TAG: /* Ok */0,
                                        _0: undefined
                                      };
                              } else {
                                return {
                                        TAG: /* Error */1,
                                        _0: "\"font-size\" attribute should be specified using \"em\" units."
                                      };
                              }
                          case "font-style" :
                              return isIncludedIntoAllowedValues(attrValue, [
                                          "normal",
                                          "italic"
                                        ], attrName);
                          case "font-weight" :
                              return isIncludedIntoAllowedValues(attrValue, [
                                          "normal",
                                          "bold"
                                        ], attrName);
                          case "href" :
                              if (attrValue.startsWith("http://") || attrValue.startsWith("https://")) {
                                return {
                                        TAG: /* Ok */0,
                                        _0: undefined
                                      };
                              } else {
                                return {
                                        TAG: /* Error */1,
                                        _0: "A link url should start with http or https, but got: " + attrValue + ""
                                      };
                              }
                          default:
                            return {
                                    TAG: /* Error */1,
                                    _0: "Attribute \"" + attrName + "\" is not supported [2]."
                                  };
                        }
                      } else {
                        return res;
                      }
                    }));
              if (attrValidation.TAG === /* Ok */0) {
                var match = Belt_MutableStack.pop(childrenStack);
                var children = match !== undefined ? match[1] : [];
                thisElem = {
                  TAG: /* Ok */0,
                  _0: Caml_splice_call.spliceApply(React.createElement, [
                        name,
                        Caml_option.option_get(createDomProps(attrs, "table" === name || "tr" === name || "td" === name)),
                        children
                      ])
                };
              } else {
                thisElem = {
                  TAG: /* Error */1,
                  _0: attrValidation._0
                };
              }
            } else {
              thisElem = {
                TAG: /* Error */1,
                _0: msg._0
              };
            }
          } else {
            thisElem = parentTagName === "table" || parentTagName === "tbody" || parentTagName === "thead" || parentTagName === "tr" ? ({
                  TAG: /* Ok */0,
                  _0: null
                }) : ({
                  TAG: /* Ok */0,
                  _0: node._0
                });
          }
          if (thisElem.TAG !== /* Ok */0) {
            return {
                    TAG: /* Error */1,
                    _0: thisElem._0
                  };
          }
          var thisElem$1 = thisElem._0;
          if (Belt_MutableStack.size(childrenStack) === 0) {
            return {
                    TAG: /* Ok */0,
                    _0: thisElem$1
                  };
          } else {
            if (thisElem$1 !== null) {
              saveChild(childrenStack, thisElem$1);
            }
            return ;
          }
        }), undefined);
  var resOpt = match[1];
  if (resOpt !== undefined) {
    return resOpt;
  } else {
    return Js_exn.raiseError("Got None as a result of convertion from XML to React Elem.");
  }
}

exports.xmlToReactElem = xmlToReactElem;
/* supportedAttrs Not a pure module */
